<template>
  <div>
    <h2 class="h2 text-light">Jouw spullen van A naar B?</h2>
    <h1 class="h1">Vul het plaats in van het ophaal- en bestemmingsadres</h1>

    <div class="row-2">
      <div class="card">
        <h3 class="h2"><i class="fas fa-map-marker-alt"></i> Ophalen</h3>
        <div
          class="form-group"
          :class="{
            'form-error': !$v.fromLocation.required && $v.fromLocation.$error
          }"
        >
          <label for="addressSearchFrom">Van plaats</label>
          <vue-bootstrap-typeahead
            ref="from"
            :data="addressesFrom"
            v-model="addressSearchFrom"
            :serializer="s => s.address.freeformAddress"
            placeholder="Amsterdam"
            @hit="fromLocation = $event"
          />
        </div>
      </div>
      <div class="card">
        <h3 class="h2"><i class="fas fa-map-marker-alt"></i> Bestemming</h3>
        <div
          class="form-group"
          :class="{
            'form-error': !$v.toLocation.required && $v.toLocation.$error
          }"
        >
          <label for="addressSearchTo">Naar plaats</label>
          <vue-bootstrap-typeahead
            ref="to"
            :data="addressesTo"
            v-model="addressSearchTo"
            :serializer="s => s.address.freeformAddress"
            placeholder="Parijs"
            @hit="toLocation = $event"
          />
        </div>
      </div>
    </div>
    <button @click="nextStep" class="btn btn__filled w-100">
      Volgende
    </button>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { required } from "vuelidate/lib/validators";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import debounce from "lodash.debounce";

export default {
  name: "Distance",
  components: {
    VueBootstrapTypeahead
  },
  data() {
    return {
      apiKey: "hZRGVbgQrLUtQ52raOjHYATfTBddlL5L",
      addressesFrom: [],
      addressesTo: []
    };
  },
  computed: {
    ...mapFields([
      "toLocation",
      "extraCountryCosts",
      "isBEOrNL",
      "fromLocation",
      "distanceSummary",
      "totalKm",
      "addressSearchFrom",
      "addressSearchTo",
      "selectedAddressTo",
      "ophaalAdres",
      "afleverAdres",
      "selectedAddressForm"
    ])
  },
  watch: {
    addressSearchFrom: debounce(function(addr) {
      this.getAddresses(addr, true);
    }, 500),
    addressSearchTo: debounce(function(addr) {
      this.getAddresses(addr);
    }, 500)
  },
  created() {
    const urlParams = new URLSearchParams(window.location.search);
    let data = urlParams.get("data");

    if (data) {
      try {
        data = window.atob(data);
        data = JSON.parse(data);

        if (
          data &&
          "fromLocation" in data &&
          "toLocation" in data &&
          "position" in data.fromLocation &&
          "position" in data.toLocation
        ) {
          this.fromLocation = data.fromLocation;
          this.toLocation = data.toLocation;
          this.addressSearchFrom = this.fromLocation.address.freeformAddress;
          this.addressSearchTo = this.toLocation.address.freeformAddress;

          window.history.pushState(
            {},
            document.title,
            window.location.pathname
          );
          this.getDistanceBetweenFromAndTo();
        }
      } catch (e) {
        console.log(e);
      }
    }
  },
  mounted() {
    if (this.fromLocation !== null) {
      this.$refs.from.inputValue = this.addressSearchFrom;
      this.ophaalAdres.plaatsnaam = this.fromLocation.address.freeformAddress;
      this.ophaalAdres.land = this.fromLocation.address.country;
    }

    if (this.toLocation !== null) {
      this.$refs.to.inputValue = this.addressSearchTo;
      this.afleverAdres.plaatsnaam = this.toLocation.address.freeformAddress;
      this.afleverAdres.land = this.toLocation.address.country;
    }
  },
  methods: {
    nextStep() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.getDistanceBetweenFromAndTo();
    },
    async getAddresses(query, from) {
      let api = `https://api.tomtom.com/search/2/search/${query}.json?limit=5&countrySet=AD,AT,BY,BE,BA,BG,HR,CZ,DK,EE,FI,FR,DE,GI,GR,HU,IS,IE,IT,LV,LI,LT,LU,MT,MC,NL,NO,PL,PT,RO,RU,SM,RS,SK,SI,ES,SE,CH,TR,UA,GB&language=nl-NL&key=${this.apiKey}&typeahead=true`;
      if (query.length > 2) {
        const res = await fetch(api);
        const suggestions = await res.json();

        if (from) {
          this.addressesFrom = suggestions.results;
        } else {
          this.addressesTo = suggestions.results;
        }
      }
    },
    async getDistanceBetweenFromAndTo() {
      const to = Object.values(this.toLocation.position).join(",");
      const from = Object.values(this.fromLocation.position).join(",");
      let api = `https://api.tomtom.com/routing/1/calculateRoute/${to}:${from}/json?key=${this.apiKey}`;
      const res = await fetch(api);
      const distance = await res.json();

      this.extraCountryCosts =
        "NL" !== this.fromLocation?.address?.countryCode ||
        "NL" !== this.toLocation?.address?.countryCode;
      this.isBEOrNL =
        ["NL", "BE"].indexOf(this.fromLocation?.address?.countryCode) !== -1 &&
        ["NL", "BE"].indexOf(this.toLocation?.address?.countryCode) !== -1;
      this.distanceSummary = distance.routes[0].summary;
      this.totalKm = Math.round(this.distanceSummary.lengthInMeters / 1000);
      this.$root.goToNextRoute();
    }
  },
  validations: {
    toLocation: {
      required,
      position: {
        lat: {
          required
        },
        lon: {
          required
        }
      }
    },
    fromLocation: {
      required,
      position: {
        lat: {
          required
        },
        lon: {
          required
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  padding: 30px 40px;
  border: 1px solid var(--light-grey);
  margin-bottom: 10px;

  .h2 {
    margin: 0;
  }
}

.row-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
  margin-bottom: 10px;

  @media only screen and (max-width: 1200px) {
    grid-template-columns: 1fr !important;
  }
}

.form-group {
  margin-top: 24px;
}
</style>
